module.exports = __webpack_public_path__ + "files/461a9cd868133ea1b8c817888828092a.png";